<template>
<div class="modal fade" id="modalChangeWsCyclic" role="dialog">
  <div class="modal-dialog">
    <!-- Modal content-->
    <div class="modal-content">
      <div class="modal-header">
        <button type="button" class="close" data-dismiss="modal">&times;</button>
        <h4 class="title-modal">Alterar dias de trabalho e dias de folga em um turno cíclico</h4>
      </div>

      <div class="modal-body">
        <form>
          <div class="form-group">
            <label>CiclicWorkingDays</label>
            <input v-model="dataChange.ciclicWorkingDays" type="number" class="form-control" name="ciclicWorkingDays" placeholder="CiclicWorkingDays" required>
            <span v-if="dataErro.errorCiclicWorkingDays" class="error-msg">{{dataErro.errorCiclicWorkingDays}}</span>
          </div>

          <div class="form-group">
            <label>CiclicFreeDays</label>
            <input v-model="dataChange.ciclicFreeDays" type="number" class="form-control" name="ciclicFreeDays" placeholder="CiclicFreeDays" required>
            <span v-if="dataErro.errorCiclicFreeDays" class="error-msg">{{dataErro.errorCiclicFreeDays}}</span>
          </div>
        </form>
      </div>

      <div class="modal-footer">
        <button v-on:click="changeWs()" :disabled="loadingChange" v-bind:class="{'disable': loadingChange}" type="submit" class="btn btn-register">
          <span v-if="!loadingChange">Salvar</span>
          <div class="loading-btn" v-else>
            <div class="spinner-btn">
              <div class="rect1"></div>
              <div class="rect2"></div>
              <div class="rect3"></div>
              <div class="rect4"></div>
              <div class="rect5"></div>
            </div>
          </div>
        </button>
        <button v-on:click="closeModal()" class="close-btn">Fechar</button>
      </div>
    </div>
  </div>
</div>
</template>

<script>
import {
  CHANGE_WS_CICLIC
} from "../../../urlConfig";
import {
  REQUEST_SERVICE
} from "../../../requestConfig";
import {
  UTIL_SERVICE
} from "../../../requestConfig";
import {
  ALERT_SERVICE
} from "../../../msgAlertService";

export default {
  name: "modalChangeWsCyclic",
  props: ['wsSelected'],
  data() {
    return {
      modalContext: '',
      dataChange: {
        workShiftId: null,
        ciclicFreeDays: null,
        ciclicWorkingDays: null
      },
      dataErro: {
        errorCiclicWorkingDays: null,
        errorCiclicFreeDays: null
      },
      setValueToReload: null,
      loadingChange: false
    }
  },
  watch: {
    wsSelected: function (val) {
      this.dataChange.workShiftId = val.id;
      this.dataChange.ciclicWorkingDays = val.ciclicWorkingDays;
      this.dataChange.ciclicFreeDays = val.ciclicFreeDays;
      this.modalContext = val.context;
    },
    setValueToReload: function (val) {
      this.$emit('update:reloadPageCyclic', val)
    }
  },
  methods: {
    closeModal() {
      $('#modalChangeWsCyclic').modal('toggle');
    },
    changeWs() {
      this.dataErro.errorCiclicWorkingDays = "";
      this.dataErro.errorCiclicFreeDays = "";
      if (this.dataChange.ciclicWorkingDays !== null && this.dataChange.ciclicFreeDays !== null) {
        this.loadingChange = true;
        UTIL_SERVICE.console("DATA SEND:", this.dataChange);
        REQUEST_SERVICE.requestContext('PUT', CHANGE_WS_CICLIC, this.modalContext, this.dataChange).then((response) => {
          UTIL_SERVICE.console("RESULT CHANGE_WS_CICLIC:", response);
          this.loadingChange = false;
          this.setValueToReload = Math.floor(Math.random() * 100) - 110;
          $('#modalChangeWsCyclic').modal('toggle');

          ALERT_SERVICE.swal("Aviso", "Turno atualizado com sucesso.", "success");

        }).catch((reason) => {
          this.loadingChange = false;
          $('#modalChangeWsCyclic').modal('toggle');

          ALERT_SERVICE.showMsgError(reason.response.data.erros);
        });
      } else {
        if (!this.dataChange.ciclicWorkingDays) {
          this.dataErro.errorCiclicWorkingDays = "Campo obrigatório";
        }

        if (!this.dataChange.ciclicFreeDays) {
          this.dataErro.errorCiclicFreeDays = "Campo obrigatório";
        }
      }
    }
  }
}
</script>

<style lang="scss">
#modalChangeWsCyclic {
  .error-msg {
    font-size: 12px;
    color: #e74a4e;
    text-align: left;
    display: block;
  }

  .modal-header {
    padding: 15px 15px 0;
    border-bottom: none;
  }

  .modal-body {
    padding-left: 80px;
    padding-right: 80px;
    margin-top: 20px;
    margin-bottom: 20px;
  }

  .title-modal {
    text-align: center;
    padding-top: 10px;
    line-height: 26px;
    font-weight: bold;
    letter-spacing: 1px;
    text-transform: uppercase;
  }

  .example-enum {
    p {
      display: inline-block;
      margin: 0 15px 5px 0;

      &:last-child {
        margin-bottom: 20px;
      }
    }
  }

  .modal-footer {
    .close-btn {
      border-radius: 4px !important;
      background-color: #8b8787;
      padding: 7px 35px 7px 35px;
      font-weight: 600;
      text-align: center;
      color: #fff;
      border: none;
      height: 36px;
    }

    .btn-register {
      border-radius: 4px !important;
      background-color: #3598dc;
      padding: 7px 35px 7px 35px;
      font-weight: 600;
      text-align: center;
      color: #fff;
      border: none;
      height: 36px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/vue/pages/modals/modalChangeWorkShiftCyclic.vue